import React from 'react';
import './_css/MCSToolTip.css';
import Tooltip from '@visa/vds/tooltip';
import Icon from '@visa/vds/icon';
import ButtonIcon from '@visa/vds/button-icon';

const MCSToolTip = (props) => {

    return(
        <Tooltip
        tooltip={props.message ? props.message : ""}
        placement={props.placement ? props.placement : "right"}
        trigger={props.trigger ? props.trigger : "hover"}
        id={props.id ? props.id : "tool-tip" + Math.random() * 100}>
            <ButtonIcon className="vss-tooltip-button" ariaLabel={props.iconName} iconType="light">
                <Icon className="vss-tooltip-icon" name={props.iconName} resolution="tiny" />
            </ButtonIcon>     
        </Tooltip>   
    )
}

export default MCSToolTip;